module.exports = __webpack_public_path__ + "img/phone_img.bea8a83e.png";